module.exports = __webpack_public_path__ + "media/images/icons/self-storage-medium-10x10-icon-640c7e493118d27470b511e95558545e.png";